module.exports = "/076c958321237351e457a25f1551005dcff1e8fc/85ec1ef9814530e2979840e6597a4fad.svg";